export default __webpack_public_path__ + "static/media/graignes4.42e96f16.jpg";